import { type CsticId } from "~/Configurators/Linear/models";
import { useCsticInputProps } from "~/Configurators/Shaft/components/useCsticInputProps";
import { type SubstepType } from "~/Configurators/Linear/dtos";
import LanguageAwareExternalContent from "~/Configurators/Linear/components/LanguageAwareExternalContent";
import { MaterialInput } from "~/common/components/materialInput/MaterialInput";

interface Props {
  className?: string;
  csticId: CsticId;
  substepType: SubstepType;
  label?: string;
  helperLabel?: string;
  disabled?: boolean;
  csticsToNull?: string[];
  csticsToSet?: Array<CsticToSet | Resolver>;
}

type CsticToSet =
  | {
      key: string;
      value: string;
    }
  | undefined;

type Resolver = (value: string | null) => CsticToSet;

export const SimpleCsticTextField = ({
  className,
  csticId,
  substepType,
  label,
  csticsToNull,
  csticsToSet,
  helperLabel,
  disabled,
}: Props) => {
  const inputProps = useCsticInputProps({
    csticId,
    substep: substepType,
    csticsToNull,
    csticsToSet,
    type: "string",
  });

  return (
    <MaterialInput
      className={className}
      label={
        label ? (
          <LanguageAwareExternalContent content={label} loadedClassname={"scha__lc__external-label"} />
        ) : undefined
      }
      helperLabel={helperLabel}
      disabled={disabled}
      {...inputProps}
      onChange={(e) => inputProps.onChange(e.target.value)}
    />
  );
};
